const FIELD_PATTERN = /^Field "(\w+)" error: (.+)$/;

/**
 * The recovery API answers errors in two shapes, depending on how the failure
 * was raised rather than on its status code:
 *  - 400/422 (invalid or spent token, weak or mismatched password): the legacy
 *    response adapter's `error` array, whose validation entries carry a
 *    `Field "x" error: ...` prefix and whose domain entries do not.
 *  - 429 (rate limited): bypasses that adapter entirely — a flat
 *    `{status: 'error', message: '<string>'}` with no `error` array.
 *
 * Returns a single string, because this page has one message area. The field
 * prefix is stripped: "Field "password" error: too short" reads as noise to
 * someone who can see which box they typed in.
 */
export function parseRecoveryError(err) {
	const status = err?.response?.status;
	const body = err?.response?.data;

	if (status === 429) {
		return body?.message || 'Too many attempts. Please try again later.';
	}

	const errors = Array.isArray(body?.error) ? body.error : [];

	if (errors.length === 0) {
		return body?.message || 'Something went wrong. Please try again.';
	}

	return errors
		.map((msg) => {
			const match = FIELD_PATTERN.exec(msg);

			return match ? match[2] : msg;
		})
		.join(' ');
}

export default parseRecoveryError;
